// src/components/Contact.js
import React, { useState, useEffect } from 'react';
import EmailApi from '../../components/common/index'; // Adjust path if needed
import './Contact.css';

function Contact() {
  const [formStatus, setFormStatus] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormStatus('Sending...');

    // Basic client-side validation
    const formData = new FormData(e.target);
    const name = formData.get('name');
    const email = formData.get('email');
    const subject = formData.get('subject');
    const message = formData.get('message');

    if (!name || !email || !subject || !message) {
      setFormStatus('Please fill all fields.');
      setTimeout(() => setFormStatus(''), 3000);
      return;
    }

    // Prepare data as URL-encoded (better for PHP forms)
    const params = new URLSearchParams();
    params.append('full_name', name);
    params.append('email', email);
    params.append('subject', subject);
    params.append('message', message);

    try {
      const { url, method } = EmailApi.SendMail;
      const response = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: params,
      });

      if (response.ok) {
        setFormStatus('Message sent successfully 🚀');
        e.target.reset();
        setTimeout(() => setFormStatus(''), 4000);
      } else {
        throw new Error(`Server error: ${response.status}`);
      }
    } catch (error) {
      console.error('API Error:', error);
      setFormStatus('Failed to send message. Please try again.');
      setTimeout(() => setFormStatus(''), 4000);
    }
  };

  useEffect(() => {
    // Dropdown logic
    const dropdowns = document.querySelectorAll('.contact-dropdown');
    dropdowns.forEach(drop => {
      const button = drop.querySelector('.contact-dropbtn');
      const content = drop.querySelector('.contact-dropdown-content');
      if (button && content) {
        button.addEventListener('click', (e) => {
          e.stopPropagation();
          const isOpen = content.style.display === 'block';
          document.querySelectorAll('.contact-dropdown-content').forEach(dc => {
            dc.style.display = 'none';
            dc.style.opacity = '0';
            dc.style.transform = 'translateY(-10px)';
          });
          if (!isOpen) {
            content.style.display = 'block';
            setTimeout(() => {
              content.style.opacity = '1';
              content.style.transform = 'translateY(0)';
            }, 10);
          }
        });
      }
    });
    document.addEventListener('click', () => {
      document.querySelectorAll('.contact-dropdown-content').forEach(dc => {
        dc.style.opacity = '0';
        dc.style.transform = 'translateY(-10px)';
        setTimeout(() => {
          dc.style.display = 'none';
        }, 400);
      });
    });
    // Hamburger and mobile menu logic
    const hamburger = document.getElementById('contact-hamburger');
    const mobileMenu = document.getElementById('contact-mobileMenu');
    const mobileClose = document.getElementById('contact-mobileClose');
    const overlay = document.getElementById('contact-overlay');
    const toggles = document.querySelectorAll('.contact-mobile-toggle');
    if (hamburger) {
      hamburger.addEventListener('click', () => {
        if (mobileMenu) mobileMenu.classList.add('contact-open');
        if (overlay) overlay.classList.add('contact-open');
      });
    }
    if (mobileClose) {
      mobileClose.addEventListener('click', () => {
        if (mobileMenu) mobileMenu.classList.remove('contact-open');
        if (overlay) overlay.classList.remove('contact-open');
      });
    }
    if (overlay) {
      overlay.addEventListener('click', () => {
        if (mobileMenu) mobileMenu.classList.remove('contact-open');
        if (overlay) overlay.classList.remove('contact-open');
      });
    }
    toggles.forEach(toggle => {
      if (toggle) {
        toggle.addEventListener('click', () => {
          if (toggle.nextElementSibling) toggle.nextElementSibling.classList.toggle('contact-open');
        });
      }
    });
    // Active link logic
    const setActiveLink = (link) => {
      document.querySelectorAll('.contact-nav-links a').forEach(l => l.classList.remove('contact-active'));
      document.querySelectorAll('.contact-mobile-nav a').forEach(l => l.classList.remove('contact-active'));
      const dropdownButton = document.querySelector('.contact-dropbtn');
      const mobileToggle = document.querySelector('.contact-mobile-toggle');
      if (dropdownButton) dropdownButton.classList.remove('contact-active');
      if (mobileToggle) mobileToggle.classList.remove('contact-active');
      if (link) {
        link.classList.add('contact-active');
        if (link.closest('.contact-dropdown-content') || link.closest('.contact-contact-page')) {
          if (dropdownButton) dropdownButton.classList.add('contact-active');
          if (mobileToggle) mobileToggle.classList.add('contact-active');
        }
      }
    };
    const currentPath = window.location.pathname.split('/').pop() || 'contact.html';
    document.querySelectorAll('.contact-nav-links a').forEach(link => {
      if (link.getAttribute('href') === currentPath) {
        setActiveLink(link);
      }
      link.addEventListener('click', () => {
        setActiveLink(link);
      });
    });
    document.querySelectorAll('.contact-mobile-nav a').forEach(link => {
      if (link.getAttribute('href') === currentPath) {
        setActiveLink(link);
      }
      link.addEventListener('click', () => {
        setActiveLink(link);
        const mobileMenu = document.getElementById('contact-mobileMenu');
        const overlay = document.getElementById('contact-overlay');
        if (mobileMenu) mobileMenu.classList.remove('contact-open');
        if (overlay) overlay.classList.remove('contact-open');
      });
    });
    const dropdownButton = document.querySelector('.contact-dropbtn');
    if (dropdownButton) {
      dropdownButton.addEventListener('click', () => {
        if (dropdownButton.classList.contains('contact-active')) {
          dropdownButton.classList.remove('contact-active');
        } else {
          setActiveLink(null);
          dropdownButton.classList.add('contact-active');
        }
      });
    }
    const mobileToggle = document.querySelector('.contact-mobile-toggle');
    if (mobileToggle) {
      mobileToggle.addEventListener('click', () => {
        if (mobileToggle.classList.contains('contact-active')) {
          mobileToggle.classList.remove('contact-active');
        } else {
          setActiveLink(null);
          mobileToggle.classList.add('contact-active');
        }
      });
    }
    // No cleanup implemented for brevity, but consider adding removeEventListener in production if needed
  }, []);

  return (
    <>
      <section className="contact-contact-page" id="oakya-contact">
        <div className="contact-overlay"></div>
        <div className="contact-container">
          <h1 className="contact-title">Contact Us</h1>
          <p className="contact-subtitle">Let’s collaborate and bring your vision to life 🚀</p>
          <div className="contact-contact-wrapper">
            <div className="contact-contact-info">
              <h2>Get in Touch</h2>
              <p><i className="fas fa-map-marker-alt"></i> <a href="https://www.google.com/maps?q=4th+Floor,+MKR+Enclave,+kamayyathopu,+Pantakaluva+Road,+NTR+Marg,+Kanuru,+Vijayawada,+Andhra+Pradesh"
                target="_blank">
                4th Floor, MKR Enclave, kamayyathopu,
                Pantakaluva Road, NTR Marg, Kanuru,
                Vijayawada, Andhra Pradesh, 520007.
              </a></p>
              <p><i className="fas fa-envelope"></i> <a href="mailto:info@oakyaitservices.com">info@oakyaitservices.com</a></p>
              <div className='contact-mobile-num'><i className="fas fa-phone-alt"></i>
              <div><a href="tel:+919134747474">+91 9134747474 </a>
                {/* <a href="tel:+919912566969">+91 9912566969</a> */}
                </div></div>
              <div className="contact-social-links">
                <a href="https://www.facebook.com/oakyaitservices"><i className="fab fa-facebook"></i></a>
                <a href="https://www.linkedin.com/company/oakya-it-services/"><i className="fab fa-linkedin"></i></a>
                <a href="https://x.com/oakyaitservices?s=21"><i className="fab fa-twitter"></i></a>
                <a href="https://www.instagram.com/oakya_itservices/"><i className="fab fa-instagram"></i></a>
              </div>
            </div>
            <form className="contact-contact-form" onSubmit={handleSubmit}>
              <div className="contact-input-group">
                <input type="text" name="name" required />
                <label>Your Name</label>
              </div>
              <div className="contact-input-group">
                <input type="email" name="email" required />
                <label>Email Address</label>
              </div>
              <div className="contact-input-group">
                <input type="text" name="subject" required />
                <label>Subject</label>
              </div>
              <div className="contact-input-group contact-textarea">
                <textarea name="message" rows="5" required></textarea>
                <label>Your Message</label>
              </div>
              <button type="submit" className="contact-btn-submit">Send Message</button>
              <p className="contact-form-status">{formStatus}</p>
            </form>
          </div>
        </div>
      </section>
    </>
  );
}

export default Contact;